module.exports = __webpack_public_path__ + "static/media/locationIcon.ffa8c32e.svg";